export default function getUserAvatarURL(user) {
    return user && user.avatar ? user.avatar : '/defaultAvatar.svg';
}
